import { PaginatedResult } from '@nx-smartmonkey/shared/interfaces';
import { Client } from '../domain/client/Client';
import { ClientFlat } from '../domain/client/ClientFlat';
import { Project } from '../domain/project/Project';
import { clientRepository } from '../repositories/client';
import { ClientRepository } from '../repositories/client/ClientRepository';

export class ClientService {
  constructor(private clientRepository: ClientRepository) {}

  async fetchClient({ clientId, project }: { clientId: string; project: Project }): Promise<Client> {
    const client = await this.clientRepository.fetchClient({ clientId, project });
    return client;
  }

  async fetchSomeClients({
    clientIds,
    project,
  }: {
    clientIds: string[];
    project: Project;
  }): Promise<Array<Client | null>> {
    const stops = await this.clientRepository.fetchSomeClients({ clientIds, project });
    return stops;
  }

  async save(client: Client, project: Project): Promise<Client> {
    const updatedClient = await this.clientRepository.save(client, project);
    return updatedClient;
  }

  async updateConstraints({
    clientIds,
    constraints,
  }: {
    clientIds: string[];
    constraints: Record<string, any>;
  }): Promise<void> {
    return this.clientRepository.updateConstraints(clientIds, constraints);
  }

  async searchClients({
    project,
    offset,
    limit,
    searchText,
    sortBy,
    sortDirection,
    deleted,
  }: {
    project: Project;
    offset?: number;
    limit?: number;
    searchText?: string;
    sortBy?: string;
    sortDirection?: string;
    deleted?: boolean;
  }): Promise<PaginatedResult<Client>> {
    const paginatedClients = await this.clientRepository.searchClients({
      project,
      offset,
      limit,
      searchText,
      sortBy,
      sortDirection,
      deleted,
    });
    return paginatedClients;
  }

  async createClients({ clients, project }: { clients: Array<Client>; project: Project }): Promise<Array<Client>> {
    const createdClients = await this.clientRepository.createClients({ clients, project });
    return createdClients;
  }

  async getFlatClients(projectId: string): Promise<ClientFlat[]> {
    return this.clientRepository.getFlatClients(projectId);
  }

  async deleteClients({ clientIds, project }: { clientIds: string[]; project: Project }) {
    return this.clientRepository.deleteClients(clientIds, project);
  }
}

export const clientService = new ClientService(clientRepository);
